module.exports = __webpack_public_path__ + "img/domi-admin-neg.ec38cb43.png";